module.exports = __webpack_public_path__ + "media/blog/bg-48ab0546.png";